module.exports = __webpack_public_path__ + "static/media/success-finish-icon.3a1c1a00.svg";